<template>
  <!--Web version-->
  <div v-if="!isMobile" class="raceFieldContainer">
    <!--Render if there is data and form data available-->
    <div v-if="Object.keys(detailedRace).length > 0 && !isMobile" class="raceFieldTable pb-3">
      <v-simple-table>
        <thead class="primary">
          <tr>
            <th class="primaryTxt" style="text-align: left;">No.</th>
            <th class="primaryTxt" style="text-align: left;">Runner</th>
            <th v-if="detailedRace.meeting.type !== 'GREYHOUND'" class="primaryTxt" style="text-align: center;">Details</th>
            <th class="primaryTxt" style="text-align: center;">Career</th>
            <th class="primaryTxt" style="text-align: center;">Track</th>
            <th class="primaryTxt" style="text-align: center;">Distance</th>
            <th
              class="primaryTxt"
              style="text-align: center;white-space:nowrap;"
              width="60"
            >Last 5</th>
            <th
              v-if="doBestOdds"
              class="primaryTxt"
              style="text-align: center;white-space:nowrap;"
              width="60"
              colspan="2">
              Best Price
            </th>
            <th
              v-if="!doBestOdds"
              class="primaryTxt"
              style="text-align: right;white-space:nowrap;"
              width="60"
            >Fixed Odds</th>
            <th class="primaryTxt" style="text-align: center;">Flucs</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in sortRunners(detailedRace.competitors)" :key="d.tabNo">
            <td width="60" style="padding: 0;text-align:right;">
              <span>
                <v-btn
                  @click="scrollToRunner(d.tabNo)"
                  outlined
                  class="font-weight-bold mr-4 caption"
                  fab
                  x-small
                  color="white"
                  style="cursor:pointer;"
                >{{d.tabNo}}</v-btn>
              </span>
            </td>
            <td style="padding-left: 0; padding-right: 0" v-if="!d.scratched">
              <div class="float-left">
                <img v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'" class="float-left mr-2 mt-1 ml-n3" :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+d.tabNo+'_64x64.png'" alt="jockey silks" height = "45">
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && d.tabNo" class="float-left mr-2 mt-1 ml-n3" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && d.tabNo" class="float-left mr-2 mt-1 ml-n3" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && d.tabNo" class="float-left mr-2 mt-1 ml-n3" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d.tabNo]" />
              </div>
              <div class="float-left">
                <div v-if="bestOddsArray.length >= 1">
                  <div style="float:left;max-width: 100px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px;" class="subtitle-2">{{d.name}}</div>
                  <div style="float:left;max-width: fit-content;" class="subtitle-2">({{d.barrier}})</div>
                  <div
                    class="red--text font-weight-black mt-1 ml-1"
                    style="font-size: 11px; float:left;"
                  >{{checkEmergencyIn(d.emergencyIndicator, d.name)}}</div>
                </div>
                <div v-else>
                  <div style="float:left;max-width: 200px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px;" class="subtitle-2">{{d.name}}</div>
                  <div style="float:left;max-width: fit-content;" class="subtitle-2">({{d.barrier}})</div>
                  <div
                    class="red--text font-weight-black mt-1 ml-1"
                    style="font-size: 11px; float:left;"
                  >{{checkEmergencyIn(d.emergencyIndicator, d.name)}}</div>
                </div>
                <br />
                <div>
                  <div v-if="!greyhoundMeeting(detailedRace)" style="font-size: 11px;text-align:left">
                    <div
                      class="float-left"
                      style="white-space: nowrap; overflow: hidden;max-width:100px;text-overflow: ellipsis;"
                    >
                      <strong v-if="!harnessMeeting(detailedRace)">J:</strong>
                      <strong v-else>D:</strong>
                      {{d.jockey}}
                    </div>
                    <template v-if="!harnessMeeting(detailedRace)">
                      <div class="float-left ml-1" v-if="d.apprenticeIndicator">
                        <b>(a{{d.allowanceWeight}}/{{d.weightTotal}}kg)</b>
                      </div>
                      <div class="float-left ml-1" v-else-if="!d.apprenticeIndicator">
                        <b>({{d.weightTotal}}kg)</b>
                      </div>
                    </template>
                  </div>
                  <div style="clear:both"></div>
                  <div style="font-size: 11px;text-align:left">
                    <div
                      class="float-left"
                      style="white-space: nowrap; overflow: hidden;max-width:100px;text-overflow: ellipsis;"
                    >
                      <strong>T:</strong>
                      {{d.trainer}}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td style="padding-left: 0;" v-else>
              <div class="float-left">
                <img v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'" class="float-left mr-2 mt-1 ml-n3" :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+d.tabNo+'_64x64.png'" alt="jockey silks" height = "45">
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && d.tabNo" class="float-left mr-2 mt-1 ml-n3" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && d.tabNo" class="float-left mr-2 mt-1 ml-n3" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d.tabNo]" />
                <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && d.tabNo" class="float-left mr-2 mt-1 ml-n3" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d.tabNo]" />
              </div>
              <div class="float-left">
                <div v-if="bestOddsArray.length >= 1">
                  <div style="float:left;max-width: 100px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px; text-decoration: line-through; color: grey" class="subtitle-2">{{d.name}}</div>
                  <div
                    class="red--text font-weight-black mt-1"
                    style="font-size: 11px; float:left;"
                  >{{checkEmergencyIn(d.emergencyIndicator, d.name)}}</div>
                </div>
                <div v-else>
                  <div style="float:left;max-width: 200px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px; text-decoration: line-through; color: grey" class="subtitle-2">{{d.name}}</div>
                  <div
                    class="red--text font-weight-black mt-1"
                    style="font-size: 11px; float:left;"
                  >{{checkEmergencyIn(d.emergencyIndicator, d.name)}}</div>
                </div>
                <br />
                <div>
                  <div v-if="!greyhoundMeeting(detailedRace)" style="font-size: 11px;text-align:left">
                    <div
                      class="float-left"
                      style="white-space: nowrap; overflow: hidden;max-width:100px;text-overflow: ellipsis; text-decoration: line-through; color: grey"
                    >
                      <strong>J:</strong>
                      {{d.jockey}}
                    </div>
                  </div>
                  <div style="font-size: 11px;text-align:left">
                    <div
                      class="float-left"
                      style="white-space: nowrap; overflow: hidden;max-width:100px;text-overflow: ellipsis; text-decoration: line-through; color: grey"
                    >
                      <strong>T:</strong>
                      {{d.trainer}}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td style="white-space: nowrap" width="100" v-if="!d.scratched && detailedRace.meeting.type !== 'GREYHOUND'">{{d.age}}YO {{d.colour.toUpperCase() || `-`}} {{d.sex}}</td>
            <td
              width="100"
              v-else-if="detailedRace.meeting.type !== 'GREYHOUND'"
              style="white-space: nowrap; text-decoration: line-through; color: grey"
            >{{d.age}}YO {{d.colour.toUpperCase() || `-`}} {{d.sex}}</td>
            <td
              v-if="d.runnerStatistics && !d.scratched"
              width="100"
              style="white-space: nowrap;"
            >
              <b>{{d.runnerStatistics.career.all.numberOfRuns}}:</b>
              {{d.runnerStatistics.career.all.firsts}}-{{d.runnerStatistics.career.all.seconds}}-{{d.runnerStatistics.career.all.thirds}}
            </td>
            <td
              v-else-if="d.runnerStatistics && d.scratched"
              style="text-decoration: line-through; color: grey; white-space: nowrap;"
              width="100"
            >
              <b>{{d.runnerStatistics.career.all.numberOfRuns}}:</b>
              {{d.runnerStatistics.career.all.firsts}}-{{d.runnerStatistics.career.all.seconds}}-{{d.runnerStatistics.career.all.thirds}}
            </td>
            <td
              v-if="d.runnerStatistics && !d.scratched"
              width="80"
              style="white-space: nowrap;"
            >
              <template
                v-for="t in mutateTrack(d.runnerStatistics.career.detail.byTrack, detailedRace.meeting.track.name)"
              >
<!--                    <div v-if="data.race.meeting.track.name == t.key" :key="t.key">-->
                <div :key="t.key">
                  <b>{{t.numberOfRuns}}:</b>
                  {{t.firsts}}-{{t.seconds}}-{{t.thirds}}
                </div>
              </template>
            </td>
            <td
              v-else-if="d.runnerStatistics && d.scratched"
              style="text-decoration: line-through; color: grey; white-space: nowrap;"
              width="80"
            >
              <template
                v-for="t in mutateTrack(d.runnerStatistics.career.detail.byTrack, detailedRace.meeting.track.name)"
              >
<!--                    <div v-if="data.race.meeting.track.name == t.key" :key="t.key">-->
                <div :key="t.key">
                  <b>{{t.numberOfRuns}}:</b>
                  {{t.firsts}}-{{t.seconds}}-{{t.thirds}}
                </div>
              </template>
            </td>
            <td
              v-if="d.runnerStatistics && !d.scratched"
              width="80"
              style="white-space: nowrap;"
            >
              <template
                v-for="(h, index) in mutateDistance(d.runnerStatistics.career.detail.byDistance, detailedRace.distance)"
              >
                <div v-if="detailedRace.distance == h.key" :key="index">
                  <b>{{h.numberOfRuns}}:</b>
                  {{h.firsts}}-{{h.seconds}}-{{h.thirds}}
                </div>
              </template>
            </td>
            <td
              v-else-if="d.runnerStatistics && d.scratched"
              style="text-decoration: line-through; color: grey; white-space: nowrap;"
              width="100"
            >
              <template
                v-for="(h, index) in mutateDistance(d.runnerStatistics.career.detail.byDistance, detailedRace.distance)"
              >
                <div v-if="detailedRace.distance == h.key" :key="index">
                  <b>{{h.numberOfRuns}}:</b>
                  {{h.firsts}}-{{h.seconds}}-{{h.thirds}}
                </div>
              </template>
            </td>
            <td width="60" v-if="!d.scratched">{{checkFinalPos(d)}}</td>
            <td
              width="60"
              v-else
              style="text-decoration: line-through; color: grey"
            >{{checkFinalPos(d)}}</td>
            <td
              v-if="!d.scratched && doBestOdds"
              width="60"
              style="text-align: right; padding-right: 0"
              class="font-weight-bold"
            >
              <div v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(d.tabNo)" :class="['logo-' + getRunnerFixedOddBookie(d.tabNo)]" style="zoom:0.75"></div>
<!--              <img v-if="bestOddsArray.length >= 1 && getRunnerFixedOddBookie(d.tabNo)" alt="..." :src="`${getRunnerFixedOddBookie(d.tabNo)}`" style="width: 32px; height: 32px; margin-top: 5px">-->
              <v-progress-circular
                v-else
                indeterminate
                color="primary"
              ></v-progress-circular>
            </td>
            <td
              v-else-if="doBestOdds"
              width="60"
              style="text-align: right">
            </td>
            <td
              v-if="!d.scratched"
              width="60"
              style="text-align: right"
              class="font-weight-bold"
            >{{getRunnerFixedOdd(d.tabNo)}}</td>
            <td v-else width="60" style="text-align: center; color: grey">Scratched</td>
            <td v-if="!d.scratched" width="60">
              <RunnerFlucs :tabNo="d.tabNo" :raceFlucs="raceFlucs" />
            </td>
            <td v-else width="60"></td>
          </tr>
        </tbody>
      </v-simple-table>
      <!--Render speedmap if it is available-->
      <template v-if="speedMapAvailable(detailedRace) && typeof featureToggle[bookie].speedMap === 'undefined'">
        <v-row justify="center" style="margin-left: 1%; margin-right: 1%">
          <v-expansion-panels v-model="panel" class="condensed mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header class="primaryTxt font-weight-bold" height="30px">
                Speed Map
                <template v-slot:actions>
                  <v-icon class="primaryTxt">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-3" color="grey lighten-3 speedMapBackLr">
                <div v-if="tenant === 'do'">
                  <div v-if="stateToRight(detailedRace.meeting.track.state)" class="text-left">
                    <h4 style="display: inline">Barrier</h4>
                    <h4 style="display: inline; float: right" class="text-right">Lead</h4>
                  </div>
                  <div v-if="stateToLeft(detailedRace.meeting.track.state)" class="text-right">
                    <h4 style="display: inline; float: left" class="text-left">Lead</h4>
                    <h4 style="display: inline">Barrier</h4>
                  </div>
                  <div v-else-if="!stateToLeft(detailedRace.meeting.track.state) && !stateToRight(detailedRace.meeting.track.state)" class="text-left">
                    <h4 style="display: inline">Barrier</h4>
                    <h4 style="display: inline; float: right" class="text-right">Lead</h4>
                  </div>
                <!--Render if the track runs to the right-->
                <v-progress-linear
                  v-if="stateToRight(detailedRace.meeting.track.state)"
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                <!--Render if the track runs to the left-->
                <v-progress-linear
                  v-if="stateToLeft(detailedRace.meeting.track.state)"
                  reverse
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                <!--Render if the track is not AU-->
                <v-progress-linear
                  v-else-if="!stateToLeft(detailedRace.meeting.track.state) && !stateToRight(detailedRace.meeting.track.state)"
                  reverse
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                </div>
                <div class="text-left" v-else>
                  <h4 style="display: inline">Barrier</h4>
                  <h4 style="display: inline; float: right" class="text-right">Lead</h4>
                </div>
                <v-progress-linear
                  reverse
                  :color="checkBookie(bookie)"
                  height="10"
                  rounded
                  class="mb-n3"
                ></v-progress-linear>
                <br />
                <div
                  v-for="d in sortByBarrier(detailedRace.competitors)"
                  :key="d.tabNo"
                  style="margin-bottom: 10px"
                >
<!--                  <RunnerSpeedMap :runner="d" :race="detailedRace" />-->
                  <NewSpeedMap :runner="d" :race="detailedRace" :tenant="tenant"/>
                  <div v-if="!d.scratched" style="height: 25px"></div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </template>
      <div v-else-if="detailedRace.meeting.type === 'GREYHOUND' || detailedRace.meeting.type === 'HARNESS'">
      </div>
      <!--Render if no speedmap data is available-->
      <!-- <div v-else>
        <br>
        <v-chip small label class="primaryTxt" color="primaryCol mt-n3">
          <div class="title font-weight-bold">
            <span>No Speedmap Data Available</span>
          </div>
        </v-chip>
      </div> -->
    </div>
  </div>
</template>

<script>
// import RunnerSpeedMap from '../components/RunnerSpeedMap'
import RunnerFlucs from '../components/RunnerFlucs'
import { featureToggle } from '../common/config'
import { mapState, mapGetters } from 'vuex'
import NewSpeedMap from './NewSpeedMap'
export default {
  name: 'RaceField',
  components: {
    NewSpeedMap,
    // RunnerSpeedMap,
    RunnerFlucs
  },
  props: {
    raceFlucs: Object,
    formAvailable: Boolean
  },
  data () {
    return {
      expansionOpen: false,
      panel: 0,
      featureToggle
    }
  },
  computed: {
    ...mapState(['bookie', 'raceNo', 'gbsID', 'detailedRace', 'bestOddsArray', 'bestPriceBookies', 'defaultBestPriceBookies']),
    ...mapGetters(['isMobile']),
    doBestOdds () {
      return window.location.host.split('.')[0] === 'do'
    },
    tenant () {
      return this.bookie
    }
  },
  methods: {
    harnessMeeting (data) {
      return data.meeting.type === 'HARNESS'
    },
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    speedMapAvailable (data) {
      let speedMapCount = 0
      // eslint-disable-next-line array-callback-return
      data.competitors.forEach((b) => {
        if (b.speedmapPosition) {
          speedMapCount += 1
        }
      })
      return speedMapCount !== 0
    },
    checkEmergencyIn (indicator, name) {
      if (indicator === true && name !== 'Vacant Box') {
        return 'E'
      } else {
        return ''
      }
    },
    sortRunners (data) {
      return data.slice().sort((a, b) => a.tabNo - b.tabNo)
    },
    getRunnerFixedOdd (tabNo) {
      let fixedPrice = 0
      if (this.bestOddsArray.length >= 1) {
        this.bestOddsArray.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            fixedPrice = b.price
          }
        })
      } else {
        this.raceFlucs.competitors.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            // eslint-disable-next-line eqeqeq
            const newPrices = b.prices.filter(b => b.type == 'WIN_FIXED_ODDS')
            const flucs = newPrices.map(a => a.price)
            fixedPrice = flucs[flucs.length - 1] || 0
          }
        })
      }
      return `$${fixedPrice.toFixed(2)}`
    },
    getRunnerFixedOddBookie (tabNo) {
      let bookie = 0
      this.bestOddsArray.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (tabNo == b.tabNo) {
          bookie = b.source
        }
      })
      return bookie
    },
    scrollToRunner (tabNo) {
      window.location.href = `#${tabNo}`
    },
    mutateDistance (distance, data) {
      let distanceObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      distance?.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (b.key == data) {
          distanceObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [distanceObj]
    },
    mutateTrack (track, data) {
      let trackObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      track?.forEach(b => {
        if (b.key === data) {
          trackObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [trackObj]
    },
    checkBookie (bookie) {
      switch (bookie) {
        case 'topsport':
          return 'light-blue'
        case 'betmakers':
          return 'pink'
        case 'uat':
          return 'pink'
        case 'neds':
          return 'orange'
        case 'do':
          return 'blue'
        case 'robwaterhouse':
          return 'purple'
        case 'realbookie':
          return 'cyan'
        case 'picnicbet':
          return 'blue darken-3'
        case 'bbet':
          return 'blue'
        case 'betdeluxe':
          return 'red'
        case 'crossbet':
          return 'cyan'
        case 'texbet':
          return 'green'
        case 'zbet':
          return 'blue'
        case 'nztab':
          return 'blue'
        case 'mailbag':
          return 'orange'
        case 'dimers':
          return 'blue'
        case 'pronet':
          return 'blue'
        case 'sportsbetting':
          return 'orange'
        case 'wishbet':
          return 'orange'
        case 'caymanasbet':
          return 'green'
        case 'betnation':
          return 'blue'
        case 'tomwaterhouse':
          return 'teal lighten-3'
        case 'getsetbet':
          return 'pink'
        case 'punt123':
          return 'blue'
        case 'marantelli':
          return 'red'
        case 'okebet':
          return 'blue'
        case 'betgold':
          return 'yellow'
        case 'monmouth':
          return 'green'
        case 'monmouthtech':
          return 'green'
        case 'bossbet':
          return 'blue'
        case 'readybet':
          return 'blue'
        case 'swiftbet':
          return 'blue'
        case 'baggybet':
          return 'orange'
        case 'upcoz':
          return 'orange'
        case 'mintbet':
          return 'green'
        case 'betr':
          return 'blue'
        case 'sportchamps':
          return 'blue'
        case 'foxcatcher':
          return 'green'
        case 'eskanderbet':
          return 'yellow'
        case 'diamondbet':
          return 'orange'
        case 'bitwinning':
          return 'orange'
        case 'thunderbet':
          return 'purple'
        case 'betestate':
          return 'yellow'
        case 'playwestbet':
          return 'blue'
        case 'chasebet':
          return 'purple'
        case 'premiumbet':
          return 'light-green'
        case 'bet66':
          return 'dark-blue'
        case 'betlocal':
          return 'purple'
      }
    },
    stateToRight (state) {
      switch (state) {
        case 'QLD':
          return true
        case 'NSW':
          return true
        case 'ACT':
          return true
      }
    },
    stateToLeft (state) {
      switch (state) {
        case 'VIC':
          return true
        case 'SA':
          return true
        case 'WA':
          return true
        case 'NT':
          return true
        case 'TAS':
          return true
      }
    },
    sortByBarrier (competitors) {
      return competitors.slice().sort((a, b) => b.barrier - a.barrier)
    },
    checkFinalPos (competitors) {
      const pastStartsFilter = competitors.formHistory.filter(e => e.class !== 'BTrial' && e.class !== 'Barrier Trial').filter((a) => a.starters > 0)
      const pastStarts = pastStartsFilter.slice(0, 5).reverse()
      const finalPos = pastStarts.map((b, index) => {
        if (index !== pastStarts.length - 1) {
          const nowTime = pastStarts[index].date
          const pastTimer = pastStarts[index + 1].date
          const nowTimeMili = new Date(nowTime).getTime()
          const pastTimeMili = new Date(pastTimer).getTime()
          const timeBetween = nowTimeMili - pastTimeMili
          const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
          const daysFormatted = Math.floor(daysBetween)
          b.dslsLast5 = Math.abs(daysFormatted)
        }
        if (b.finishingPosition > 9) {
          return 0
        }
        if (b.dslsLast5 >= 84) {
          return b.finishingPosition + 'x'
        }
        return b.finishingPosition
      })
      const finalPosStr = finalPos.toString()
      const final = finalPosStr.replace(/,/g, '')
      return final
    }
  }
}
</script>

<style scoped>
.v-progress-linear__determinate {
  border-radius: 10px;
}
.raceFieldContainer {
  max-width: 1024px;
  min-width: 1024px;
  box-shadow: 3px 5px 5px lightgrey;
}
.v-expansion-panels.condensed .v-expansion-panel-header {
  padding-top: 6px;
  padding-bottom: 6px;
  min-height: auto;
}
.v-expansion-panels.condensed
  .v-expansion-panel--active
  .v-expansion-panel-header {
  padding-top: 12px;
  padding-bottom: 12px;
}
.v-expansion-panels.condensed .v-expansion-panel--active:not(:first-child),
.v-expansion-panels.condensed .v-expansion-panel--active + .v-expansion-panel {
  margin-top: 4px;
}
.logoWidth {
  width: 55px;
  text-align: center;
}
.logo-WH {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 450px;
  background-size: 90px;
  margin: 0 auto;
}
/* RealBookie*/
.logo-RB3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px 0px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetDeluxe*/
.logo-BD2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px -180px;
  background-size: 90px;
  margin: 0 auto;
}
/* Dave Dwyer*/
.logo-DD {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px -585px;
  background-size: 90px;
  margin: 0 auto;
}
/* Tab Touch WA*/
.logo-OB {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 45px;
  background-size: 90px;
  margin: 0 auto;
}
/* Topsport*/
.logo-TS2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 360px;
  background-size: 90px;
  margin: 0 auto;
}
/* Sportsbet*/
.logo-SB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 540px;
  background-size: 90px;
  margin: 0 auto;
}
/* Betfair*/
.logo-BF {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -225px;
  background-size: 90px;
  margin: 0 auto;
}
/* Ladbrokes AU*/
.logo-LB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -495px;
  background-size: 90px;
  margin: 0 auto;
}
/* Topbetta with a twisit*/
.logo-TB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 315px;
  background-size: 90px;
  margin: 0 auto;
}
/* Official Price*/
.logo-OP {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -585px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetVictor*/
.logo-BV {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -270px;
  background-size: 90px;
  margin: 0 auto;
}
/* SkyBet*/
.logo-SB6 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 585px;
  background-size: 90px;
  margin: 0 auto;
}
/* Coral*/
.logo-CB3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -405px;
  background-size: 90px;
  margin: 0 auto;
}
/* Boyle Sports*/
.logo-BS3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -360px;
  background-size: 90px;
  margin: 0 auto;
}
/* RaceBets*/
.logo-RB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 630px;
  background-size: 90px;
  margin: 0 auto;
}
/* BlueBet*/
.logo-BB3 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -315px;
  background-size: 90px;
  margin: 0 auto;
}
/* Unibet*/
.logo-UB {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 405px;
  background-size: 90px;
  margin: 0 auto;
}
/* Ladbrokes UK*/
.logo-LB2U {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 675px;
  background-size: 90px;
  margin: 0 auto;
}
/* Playup*/
.logo-CB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 45px -135px;
  background-size: 90px;
  margin: 0 auto;
}
/* Bet365*/
.logo-BT {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -90px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetEasy*/
.logo-BE {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -180px;
  background-size: 90px;
  margin: 0 auto;
}
/* Sportsbetting*/
.logo-SB5 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 495px;
  background-size: 90px;
  margin: 0 auto;
}
/* GT*/
.logo-GT {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -450px;
  background-size: 90px;
  margin: 0 auto;
}
/* BestBookies*/
.logo-BB2 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -45px;
  background-size: 90px;
  margin: 0 auto;
}
/* BBet*/
.logo-BB4 {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 0px;
  background-size: 90px;
  margin: 0 auto;
}
/* BetDogs*/
.logo-BD {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -135px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB NZ*/
.logo-NZ {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 90px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB Sportsbet (TAB QLD)*/
.logo-TS_Q {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 180px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB (TAB QLD)*/
.logo-Q {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 180px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB Sportsbet (TAB VIC)*/
.logo-TS_V {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 270px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB (TAB VIC)*/
.logo-V {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 270px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB NSW*/
.logo-N {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 225px;
  background-size: 90px;
  margin: 0 auto;
}
/* TAB NSW Sportsbet*/
.logo-TS_N {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 225px;
  background-size: 90px;
  margin: 0 auto;
}
/* Neds*/
.logo-ND {
  width: 45px;
  height: 45px;
  background: url('~@/assets/DO_BookieLogosSprite_icons.png') 0 -540px;
  background-size: 90px;
  margin: 0 auto;
}
/* UK Greys */
.greyhoundSpriteUk-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUk-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUk-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUk-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUk-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUk-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUk-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUk-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -196px;
}
/* AUS Greys */
.greyhoundSpriteAUS-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteAUS-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteAUS-3 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteAUS-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteAUS-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteAUS-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteAUS-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteAUS-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteAUS-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteAUS-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -252px;
}
/* US Greys */
.greyhoundSpriteUs-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUs-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUs-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUs-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUs-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUs-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUs-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUs-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteUs-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteUs-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -252px;
}
</style>
